import React from 'react'

import { useSelector } from 'store/redux.store'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

export const ButtonGotoCollaboratorsArea = () => {
  const user = useSelector(state => state.user)
  const { t } = useTranslation()
  const history = useHistory()

  function handleClickManageAreas() {
    history.push('/tools/collaborators-area')
  }

  return user.entityType === 'LEGAL_ENTITY' ? (
    <div className="_w-full">
      <h5 className="_mb-0 _text-3 _text-gray-700">{t('header.menu.general.collaborators_area')}</h5>
      <p className="_mb-0">{t('collaborators_area.manage_your_team')}</p>
      <button onClick={handleClickManageAreas} className="hot-button hot-button--info hot-button--block _mt-2">
        {t('collaborators_area.go_to_cta')}
      </button>
    </div>
  ) : null
}
